import { render, staticRenderFns } from "./BusinessnewsDetail.vue?vue&type=template&id=41fcc10a&scoped=true"
import script from "./BusinessnewsDetail.vue?vue&type=script&lang=js"
export * from "./BusinessnewsDetail.vue?vue&type=script&lang=js"
import style0 from "./BusinessnewsDetail.vue?vue&type=style&index=0&id=41fcc10a&prod&scoped=true&lang=css"
import style1 from "./BusinessnewsDetail.vue?vue&type=style&index=1&id=41fcc10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fcc10a",
  null
  
)

export default component.exports